import { useCallback, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import DisplayContainer from "../../../../components/displayContainer/DisplayContainer";
import Loader from "../../../../components/loader/Loader";
import TextWrapper from "../../../../components/textWrapper/TextWrapper";
import { fetchAdmins } from "../../../../features/admins/adminsSlice";
import { fetchPaginatedTournament } from "../../../../features/tournaments/tournamentsSlice";
import OneTournamentAccess from "./oneTournamentAccess/OneTournamentAccess";
import styles from "./tournamentAccess.module.css";

const TournamentAccess = () => {
  const dispatch = useDispatch();
  const {
    list: tournaments,
    fetchStatus,
    currentPage,
    totalPages,
  } = useSelector((state) => state.tournaments);
  const { fetchStatus: adminsFetchStatus } = useSelector(
    (state) => state.admins
  );
  useEffect(() => {
    if (adminsFetchStatus === "idle") {
      dispatch(fetchAdmins());
    }
  }, [adminsFetchStatus, dispatch]);

  const tournamentListRef = useRef();

  const displayTournaments = tournaments.map((item) => {
    return (
      <OneTournamentAccess
        tournamentId={item._id}
        key={item._id}
        status={item.status}
        name={item.name}
        serialNumber={item.serialNumber}
        createdBy={item.createdBy}
        startDate={item.startDate}
        endDate={item.endDate}
        prize={item.prize}
        tournamentImage={item.tournamentImage}
      />
    );
  });

  const handleScroll = useCallback(() => {
    const container = tournamentListRef.current;
    if (!container || fetchStatus === "loading") return;

    const { scrollTop, scrollHeight, clientHeight } = container;
    if (
      scrollTop + clientHeight >= scrollHeight - 50 &&
      currentPage < totalPages
    ) {
      dispatch(fetchPaginatedTournament({ page: currentPage + 1 }));
    }
  }, [dispatch, fetchStatus, currentPage, totalPages]);

  useEffect(() => {
    if (fetchStatus === "idle") {
      dispatch(fetchPaginatedTournament({ page: 1 }));
    }
  }, [dispatch, fetchStatus]);

  useEffect(() => {
    const container = tournamentListRef.current;
    if (!container) return;

    container.addEventListener("scroll", handleScroll);

    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, [dispatch, currentPage, totalPages, handleScroll]);

  return (
    <div className={styles.container}>
      <TextWrapper textStyle="textTitle">
        التحكم في الوصول الى البطولات
      </TextWrapper>
      <div className={styles.allAdminsWrapper}>
        <DisplayContainer ref={tournamentListRef}>
          {displayTournaments}
          {fetchStatus === "loading" && (
            <div className={styles.loaderContainer}>
              <Loader />
            </div>
          )}
        </DisplayContainer>
      </div>
    </div>
  );
};

export default TournamentAccess;
